<template>
  <a href="#" class="load-more" v-if="isVisible" @click.prevent="handleClick">
    <i class="fas fa-chevron-down"></i>
  </a>
</template>

<script setup>
defineProps({
  isVisible: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click:loadMore']);

const handleClick = () => {
  emit('click:loadMore');
};
</script>
